<template>
    <div>
        <v-text-field v-model="search" label="Search"></v-text-field>
        <v-data-table :headers="headers"
                      :items="array_membresias"
                      :items-per-page="5"
                      :search="search"
                      class="elevation-1">

            <template v-slot:item.action="{ item }">
                <v-btn small @click="editar(item)"> <v-icon left>mdi-draw</v-icon>Editar</v-btn>
                <v-btn small @click="dialog=true;selected_id=item.id;"><v-icon left>delete</v-icon>Eliminar</v-btn>
            </template>
        </v-data-table>

        <div class="text-left pt-2">
            <v-btn color="primary" @click="Crear">Crear</v-btn>
        </div>

        <template>
            <v-row justify="center">
                <v-dialog v-model="dialog" persistent max-width="290">
                    <v-card>
                        <v-card-title class="headline"></v-card-title>
                        <v-card-text>Desea eliminar el item {{selected_id}}?</v-card-text>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn color="red darken-1" text @click="dialog = false;">No</v-btn>
                            <v-btn color="green darken-1" text @click="dialog = false;eliminar();  ">Si</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>
            </v-row>
        </template>

        <v-snackbar v-model="notificacion_exito">
            {{ texto_notificacion }}
            <v-btn color="pink"
                   text
                   @click="notificacion_exito = false; texto_notificacion.indexOf('Error') >= 0 ? null:reset() ;">
                Cerrar
            </v-btn>
        </v-snackbar>
    </div>
</template>
<script>
    
    import axios from "axios";

  export default {
    data () {
        return {
            search: "",
            dialog: false,
            selected_id: 0,
             notificacion_exito: false,
            texto_notificacion: '',
        headers: [
          {
            text: 'Id',
            align: 'start',
            sortable: false,
            value: 'id',
          },
          { text: 'Nombre', value: 'nombre' },
          { text: 'Dias de Vigencia', value: 'dias_vigencia' },
          { text: 'Firmas Permitidas', value: 'firmas_permitidas' },
          { text: 'action', value: 'action' }
          ],
          array_membresias: [
          ]     
      }
        },
        mounted() {
            console.log("Mounted");
  	        this.getMembresias();
        },
        methods: {
            eliminar() {
                    console.log("Deleting Item id :" + this.selected_id)

                    let getuser = axios.delete('/membresia/' + this.selected_id , { 'headers': this.$store.state.user.headers })
                    return getuser.then((callback) => {
                        let resultado = callback.data;
                        this.texto_notificacion = 'Operacion finalizada con exito';
                        this.notificacion_exito = true;

                        console.log('Eliminando el item : ' + this.selected_id);

                        this.array_membresias.splice(this.array_membresias.findIndex(e => e.id == this.selected_id), 1);

                        return callback;

                    }).catch((error) => {
                        this.texto_notificacion = 'Error al realizar la operacion : ' + error;
                        this.notificacion_exito = true;
            	        console.log(error);
            	        return false;
                    });

                
            },
            editar(item) {
                console.log("editando: " + item.id);
                   this.$router.push({ name: "edit_membresia", params: { "Id": item.id } });
            },

            Crear() {
                  this.$router.push({ name: "new_membresia" });
            },
            getMembresias() {
                console.log("REcuperado listado de membresias");
                let getMembresias = axios.get('/membresia/', { 'headers': this.$store.state.user.headers } );
                return getMembresias.then((callback) =>
                {
                       console.log(callback);
                       this.array_membresias = callback.data;        
                }).catch((error) => {
                    console.log("ERROR EN EL CALLBACK" + error);
                });
            }
        }
  }
</script>